import React, { useId } from 'react';

import { Input } from '../ui';
import { Field, FieldDescription, FieldError, FieldLabel } from '../ui/field';

interface FieldInputProps extends React.ComponentProps<'input'> {
  label?: string;
  description?: string;
  errors?: Array<{ message?: string } | undefined>;
}

export const FieldInput = React.forwardRef<HTMLInputElement, FieldInputProps>(
  function FieldInput(
    {
      id,
      value,
      label,
      description,
      errors,
      placeholder = '0.00',
      required = false,
      disabled = false,
      type = 'text',
      ...props
    },
    ref
  ) {
    const internalId = useId();
    const inputId = id ?? internalId;

    return (
      <Field data-invalid={errors?.some(e => e?.message) ? 'true' : (required && !value ? 'true' : undefined)}>
        {label && (
          <FieldLabel htmlFor={inputId} className='gap-1'>
            {label} {required && <span className='text-destructive'>*</span>}
          </FieldLabel>
        )}

        <Input
          id={inputId}
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={props.onChange}
          required={required}
          disabled={disabled}
          aria-invalid={required && !value ? 'true' : undefined}
          ref={ref}
          {...props}
        />

        {description && <FieldDescription>{description}</FieldDescription>}
        <FieldError errors={errors} />
      </Field>
    );
  }
);
